import HomeIcon from '@mui/icons-material/Home';
import PublicIcon from '@mui/icons-material/Public';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';

const GRADIENT = 'linear-gradient(135deg, #8a2be2, #FFD700)';

const NAV_ITEMS = [
  { label: 'ホーム', path: '/dashboard', icon: HomeIcon },
  { label: 'タイムライン', path: '/timeline', icon: PublicIcon },
];

export const SIDEBAR_WIDTH = 220;

export function Sidebar({ nickname, profileImageURL }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isProfileSelected = location.pathname === '/profile';

  return (
    <Box
      component="nav"
      sx={{
        width: SIDEBAR_WIDTH,
        flexShrink: 0,
        bgcolor: '#111118',
        borderRight: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <List sx={{ px: 1, py: 2, flexGrow: 1 }}>
        {NAV_ITEMS.map(({ label, path, icon: Icon }) => {
          const isSelected = location.pathname === path;
          return (
            <ListItemButton
              key={path}
              onClick={() => navigate(path)}
              sx={{
                borderRadius: 2,
                mb: 0.5,
                position: 'relative',
                pl: 2.5,
                ...(isSelected && {
                  bgcolor: 'rgba(138, 43, 226, 0.1)',
                  '&:hover': { bgcolor: 'rgba(138, 43, 226, 0.15)' },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 3,
                    height: 24,
                    borderRadius: 2,
                    background: GRADIENT,
                  },
                }),
                ...(!isSelected && {
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.04)' },
                }),
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Icon sx={{ color: isSelected ? '#FFD700' : 'rgba(255,255,255,0.4)', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primary={label}
                slotProps={{
                  primary: {
                    sx: {
                      fontWeight: isSelected ? 700 : 400,
                      color: isSelected ? '#FFFFFF' : 'rgba(255,255,255,0.6)',
                      fontSize: '0.85rem',
                    },
                  },
                }}
              />
            </ListItemButton>
          );
        })}
      </List>

      {/* プロフィールセクション */}
      <ButtonBase
        onClick={() => navigate('/profile')}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1.5,
          borderTop: '1px solid rgba(255,255,255,0.06)',
          width: '100%',
          justifyContent: 'flex-start',
          borderRadius: 0,
          ...(isProfileSelected && {
            bgcolor: 'rgba(138, 43, 226, 0.1)',
          }),
          '&:hover': {
            bgcolor: isProfileSelected ? 'rgba(138, 43, 226, 0.15)' : 'rgba(255,255,255,0.04)',
          },
        }}
      >
        <Avatar
          src={profileImageURL}
          sx={{ width: 32, height: 32, border: isProfileSelected ? '2px solid #FFD700' : 'none' }}
        />
        <Typography
          variant="body2"
          sx={{
            color: isProfileSelected ? '#FFFFFF' : 'rgba(255,255,255,0.6)',
            fontWeight: isProfileSelected ? 700 : 400,
            fontSize: '0.85rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {nickname}
        </Typography>
      </ButtonBase>
    </Box>
  );
}
